import GetApi from '../../../common/api/get'

export function setState(params) {
  return {
    type: 'SET_STATE_PROPERTY_TYPES',
    params: params
  }
}

export function get() {
  return async (dispatch, getState) => {
    const getApi = new GetApi()
    await getApi.execute(routeUrlHelper.classificationsPropertyTypesPath(), '').then((res) => {
      dispatch(setState({ property_types: res.body.property_type_list }))
      return true
    }, (res) => {
      dispatch(setState({ error: { main: 'An error occurred' } }))
      return false
    })
  }
}
